class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-reviews-track]');
    this.progressBar = this.querySelector('[data-reviews-progress]');
    this.prevButton = this.querySelector('[data-reviews-prev]');
    this.nextButton = this.querySelector('[data-reviews-next]');
    this.cards = this.querySelectorAll('.reviews__card');

    if (!this.track || !this.progressBar || !this.prevButton || !this.nextButton) return;

    this.onScroll = this.onScroll.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.prevButton.addEventListener('click', this.onPrev);
    this.nextButton.addEventListener('click', this.onNext);

    const resizeObserver = new ResizeObserver(() => this.update());
    resizeObserver.observe(this.track);
    if (this.cards.length > 0) {
      resizeObserver.observe(this.cards[0]);
    }

    this.update();
  }

  getScrollStep() {
    const card = this.cards[0];
    if (!card) return this.track.clientWidth;

    const styles = window.getComputedStyle(this.track.querySelector('.reviews__cards'));
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.offsetWidth + gap;
  }

  onPrev(event) {
    event.preventDefault();
    this.track.scrollBy({ left: -this.getScrollStep(), behavior: 'smooth' });
  }

  onNext(event) {
    event.preventDefault();
    this.track.scrollBy({ left: this.getScrollStep(), behavior: 'smooth' });
  }

  onScroll() {
    this.update();
  }

  update() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    if (maxScroll <= 0) {
      this.progressBar.style.width = '100%';
      this.progressBar.style.left = '0';
      this.prevButton.disabled = true;
      this.nextButton.disabled = true;
      return;
    }

    const visibleRatio = this.track.clientWidth / this.track.scrollWidth;
    const scrollRatio = this.track.scrollLeft / maxScroll;
    const barWidth = visibleRatio * 100;
    const barOffset = scrollRatio * (100 - barWidth);

    this.progressBar.style.width = `${barWidth}%`;
    this.progressBar.style.left = `${barOffset}%`;

    this.prevButton.disabled = this.track.scrollLeft <= 1;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
  }
}

customElements.define('reviews-slider', ReviewsSlider);
